import {locales} from "Constants/constants";

export function filterActivitiesByLocale(activities = [], locale){
  const _locale = formatLocale_UpperCaseHyphen(locale);
  return activities.filter(activity => {
    return (_locale === locales.ES_MX && isSpanishActivity(activity))
      || (_locale !== locales.ES_MX && !isSpanishActivity(activity));
  });
}

function isSpanishActivity(activity){
  return activity.tags && activity.tags.includes("ES_MX");
}

export function isSpanishStory(story){
  return story.tags && story.tags.includes("ES-MX");
}

export function formatLocale_LowerCaseHyphen(locale){
  return locale ? formatLocale_Hyphen(locale).toLowerCase() : locale;
}

export function formatLocale_UpperCaseHyphen(locale){
  return locale ? formatLocale_Hyphen(locale).toUpperCase() : locale;
}

export function formatLocale_UpperCaseUnderscore(locale){
  return locale ? locale.replace('-', '_').toUpperCase() : locale;
}

export function formatLocale_Hyphen(locale){
  return locale ? locale.replace('_', '-') : locale;
}

export function getLanguageForLocale(locale){
  return locale === 'es-mx' ? 'es' : 'en';
}